import apiFetch from '../apiFetch'

export default function (fuelId, token) {
  return apiFetch({ endPoint: 'Fuel/' + fuelId, method: 'DELETE', body: null, token: token })
}
